import { z } from 'zod';
import { validator } from '@xeppt/xeppt-sdk';

interface IProps {
    messages: {
        oldPassword: string;
        newPassword: string;
        password_confirm: string;
    };
}

export const changePasswordValidation = ({ messages }: IProps) => {
    return z
        .object({
            oldPassword: validator.password(messages.newPassword),
            newPassword: validator.password(messages.newPassword),
            password_confirm: validator.password(messages.password_confirm)
        })
        .refine((data) => data.newPassword === data.password_confirm, {
            message: messages.password_confirm,
            path: ['password_confirm']
        });
};
